import React from 'react'
import {
  Avatar,
  Box,
  Flex,
  IconButton,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useDisclosure
} from '@chakra-ui/react'
import { FiZoomIn } from 'react-icons/fi'

interface PatientAvatarPreviewProps {
  src?: string | null
  name?: string
  size?: string
}

export const PatientAvatarPreview = ({
  src,
  name = 'Paciente',
  size = 'lg'
}: PatientAvatarPreviewProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const hasImage = Boolean(src)

  return (
    <>
      <Box
        position="relative"
        display="inline-block"
        cursor={hasImage ? 'pointer' : 'default'}
        onClick={hasImage ? onOpen : undefined}
        role={hasImage ? 'button' : undefined}
        aria-label={hasImage ? `Abrir foto de ${name}` : undefined}
      >
        <Avatar
          size={size}
          name={name}
          src={src || ''}
          border="2px solid"
          borderColor="gray.100"
          boxShadow="md"
          transition="all 0.2s ease"
          _hover={
            hasImage
              ? {
                transform: 'scale(1.05)',
                boxShadow: 'lg',
                opacity: 0.9
              }
              : undefined
          }
        />

        {hasImage && (
          <Flex
            position="absolute"
            bottom="-2px"
            right="-2px"
            w="24px"
            h="24px"
            borderRadius="full"
            bg="blue.500"
            color="white"
            align="center"
            justify="center"
            boxShadow="md"
            border="2px solid white"
          >
            <FiZoomIn size={13} />
          </Flex>
        )}
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
        <ModalOverlay
          bg="blackAlpha.700"
          backdropFilter="blur(6px)"
        />

        <ModalContent
          bg="white"
          borderRadius="2xl"
          overflow="hidden"
          boxShadow="2xl"
          mx={4}
        >
          <ModalCloseButton
            color="white"
            bg="blackAlpha.500"
            borderRadius="full"
            _hover={{ bg: 'blackAlpha.700' }}
            zIndex={2}
          />

          <ModalBody p={0}>
            <Box
              bg="gray.900"
              minH="420px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              position="relative"
            >
              <Image
                src={src || ''}
                alt={`Foto de ${name}`}
                maxH="75vh"
                maxW="100%"
                objectFit="contain"
              />
            </Box>

            <Box p={4} textAlign="center">
              <Text fontWeight="semibold" fontSize="lg">
                {name}
              </Text>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}